import React from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import useTranslation from '../../../shared/hooks/useTranslation';

const DevBanner: React.FC = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <div id="dev-banner" className="fixed top-16 left-0 right-0 bg-gradient-to-r from-blue-600/90 via-indigo-600/90 to-blue-600/90 backdrop-blur-md border-b-2 border-blue-500/50 z-40 notification-game">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4 justify-between">
        <div className="flex items-center gap-4">
          <i className="fas fa-tools text-white text-2xl animate-pulse"></i>
          <div>
            <h3 className="text-lg font-semibold text-white mb-1">🚧 {t('dev.title')}</h3>
            <p className="text-blue-100 text-sm">
              {t('dev.message')}
            </p>
          </div>
        </div>
        <a
          href="https://discord.gg/7wVa8EkvnP"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200 flex items-center gap-2 whitespace-nowrap border border-white/30 hover:scale-105"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
          </svg>
          {t('dev.discord')}
        </a>
      </div>
    </div>
  );
};

export default DevBanner;

